import useSession from '@/hooks/useSession';
import styles from './list.module.scss';
import { NavLink } from 'react-router-dom';
import { FC, useState } from 'react';
import LoadingSpinner from '../LoadingSpinner';

interface ListProps {
  items: Array<{
    path: string;
    title: string;
    badge?: string;
    subtitle: string;
    isLoading?: boolean;
    onClick?: () => void;
  }>;
  enableSearch?: boolean;
}

const List: FC<ListProps> = ({ items = [], enableSearch = false }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredItems =
    enableSearch && searchTerm
      ? items.filter((item) =>
          item.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : items;
  const { pushUserEvent } = useSession();
  return (
    <>
      {enableSearch && (
        <div className={styles['search-wrapper']}>
          <input
            type="search"
            placeholder="Search..."
            className={styles['search']}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            aria-label="Search items"
          />
          <span>
            {items.length === 0
              ? 'No items available'
              : filteredItems.length === 0 && searchTerm
                ? 'No results found'
                : `Showing ${filteredItems.length} of ${items.length}`}
          </span>
        </div>
      )}
      <ul className={styles['list']}>
        {filteredItems.length > 0 && (
          <>
            {filteredItems.map(
              ({ title, badge, subtitle, path, isLoading, onClick }, i) => {
                return (
                  <li key={i}>
                    <NavLink
                      data-testid="list-item"
                      to={path}
                      onClick={() => {
                        if (isLoading) {
                          return;
                        }
                        pushUserEvent('click_list_item');
                        if (onClick) {
                          onClick();
                        }
                      }}
                      data-loading={isLoading}
                      title={title}
                    >
                      {isLoading && (
                        <LoadingSpinner className={styles['item-icon']} />
                      )}

                      {title}
                      <p>
                        <span className={styles['item-subtitle']}>
                          {subtitle}
                        </span>

                        {typeof badge !== 'undefined' && (
                          <i className={styles['item-badge']}>Sharepoint</i>
                        )}
                        {isLoading && <strong>[PROCESSING]</strong>}
                      </p>
                    </NavLink>
                  </li>
                );
              }
            )}
          </>
        )}
      </ul>
    </>
  );
};

export default List;
